module.exports = __webpack_public_path__ + "img/za.06e2a985.svg";